(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.review-card-slider', {
      slidesPerView: 3,
      spaceBetween: 16,
      loop: true,
      navigation: {
        nextEl: '.review-button-next',
        prevEl: '.review-button-prev',
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          centeredSlides: true,
        },
        600: {
          slidesPerView: 2,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: 3,
          centeredSlides: false,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.featured-product-swiper', {
      autoHeight: true,
      slidesPerView: 1,
      spaceBetween: 30,
      navigation: {
        nextEl: '.product-swiper-button-next',
        prevEl: '.product-swiper-button-prev',
      },
      loop: true,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-marquee"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  let hb_logo_swiper;

  function initHbLogoSwiper() {
    // destroy previous instance if exists
    if (hb_logo_swiper) hb_logo_swiper.destroy(true, true);

    hb_logo_swiper = new Swiper('.marquee-track', {
      slidesPerView: 'auto',
      spaceBetween: 50,
      speed: 5000,
      loop: true,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
    });
  }

  initHbLogoSwiper();
  window.addEventListener('resize', initHbLogoSwiper);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kite-cards-blocks"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let kiteSwiper = null;

    function initKiteSwiper() {
      if (window.innerWidth <= 767 && !kiteSwiper) {
        kiteSwiper = new Swiper('.kite-cards-wrapper', {
          slidesPerView: 1,
          spaceBetween: 20,
          pagination: {
            clickable: true,
          },
          navigation: {
            nextEl: '.kite-swiper-button-next',
            prevEl: '.kite-swiper-button-prev',
          },
        });
      } else if (window.innerWidth > 767 && kiteSwiper) {
        kiteSwiper.destroy(true, true);
        kiteSwiper = null;
      }
    }

    initKiteSwiper();
    window.addEventListener('resize', initKiteSwiper);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kitty-spec-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const swiperEl = document.querySelector('.kitty-specs-swiper');
    if (swiperEl && !swiperEl.classList.contains('swiper-initialized')) {
      new Swiper(swiperEl, {
        autoHeight: true,
        slidesPerView: 1,
        spaceBetween: 16,
        loop: false,
        navigation: {
          nextEl: '.spc-button-next',
          prevEl: '.spc-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logos"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let kiteSwiper = null;

    function initKiteSwiper() {
      if (window.innerWidth <= 991 && !kiteSwiper) {
        kiteSwiper = new Swiper('.logo-box-row', {
          loop: true,
          speed: 5000,
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
          },
          allowTouchMove: false,
          breakpoints: {
            0: {
              slidesPerView: 2,
              spaceBetween: 12,
            },
            601: { 
              slidesPerView: 3,
              spaceBetween: 24,
            }
          }
        });

        // force linear flow
        document.querySelector('.logo-box-row .swiper-wrapper')
          .style.transitionTimingFunction = 'linear';
      } else if (window.innerWidth > 991 && kiteSwiper) {
        kiteSwiper.destroy(true, true);
        kiteSwiper = null;
      }
    }

    initKiteSwiper();
    window.addEventListener('resize', initKiteSwiper);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-specs-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const swiperEl = document.querySelector('.product-specs-swiper');
    if (swiperEl && !swiperEl.classList.contains('swiper-initialized')) {
      new Swiper(swiperEl, {
        autoHeight: true,
        slidesPerView: 1,
        spaceBetween: 16,
        loop: false,
        navigation: {
          nextEl: '.spc-button-next',
          prevEl: '.spc-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["real-people-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let videoSwiper = null;

    function initvideoSwiper() {
      if (window.innerWidth <= 767 && !videoSwiper) {
        videoSwiper = new Swiper('.video-swiperr-wrapper', {
          slidesPerView: 'auto', // allows custom width
          centeredSlides: true, // keep active slide in center
          spaceBetween: 20,
          loop: true,
          navigation: {
            nextEl: '.video-swiper-button-next',
            prevEl: '.video-swiper-button-prev',
          },
        });
      } else if (window.innerWidth > 767 && videoSwiper) {
        videoSwiper.destroy(true, true);
        videoSwiper = null;
      }
    }

    initvideoSwiper();
    window.addEventListener('resize', initvideoSwiper);
  });

  document.addEventListener('DOMContentLoaded', function () {
    let kiteSwiper = null;

    function initKiteSwiper() {
      if (window.innerWidth <= 1199 && !kiteSwiper) {
        kiteSwiper = new Swiper('.icon-mobile-box', {
          loop: true,
          speed: 5000,
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
          },
          breakpoints: {
            0: {
              slidesPerView: 1.6,
              spaceBetween: 0,
            },
            500: {
              slidesPerView: 3,
              spaceBetween: 0,
            },
          },
        });
        document.querySelector('.icon-mobile-box .swiper-wrapper').style.transitionTimingFunction = 'linear';
      } else if (window.innerWidth > 1199 && kiteSwiper) {
        kiteSwiper.destroy(true, true);
        kiteSwiper = null;
      }
    }

    initKiteSwiper();
    window.addEventListener('resize', initKiteSwiper);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let socialSwiper = null;

    function initsocialSwiper() {
      // Destroy previous instance
      if (socialSwiper) {
        socialSwiper.destroy(true, true);
      }

      const isMobile = window.innerWidth < 767;

      socialSwiper = new Swiper('.marquee-track', {
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: true,
        spaceBetween: 0,
        speed: isMobile ? 500 : 10000, // slower on mobile
        autoplay: !isMobile
          ? {
              delay: 0,
              disableOnInteraction: false,
            }
          : false,
        navigation: isMobile
          ? {
              nextEl: '.social-swiper-button-next',
              prevEl: '.social-swiper-button-prev',
            }
          : false,
      });

      if (!isMobile) {
        // Only apply linear transition on desktop autoplay
        const wrapper = document.querySelector('.swiper-wrapper');
        if (wrapper) {
          wrapper.style.transitionTimingFunction = 'linear';
        }
      }
    }

    initsocialSwiper();

    // Re-initialize on resize
    window.addEventListener('resize', function () {
      initsocialSwiper();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["two-column-banner-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper !== 'undefined') {
      new Swiper('.banner-swipper', {
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
